import PopUpViewProcess from "../viewflowprocess/PopUpViewProcess";
import PopUpViewFlowstatus from "../viewflowprocess/PopUpViewFlowstatus";
import PageviewIcon from '@mui/icons-material/Pageview';
import Tooltip from '@mui/material/Tooltip';
import Stepflow from "../workflow/stepflow";
import { BsSendCheckFill } from "react-icons/bs";
import { RiFileEditFill } from "react-icons/ri";
import { Link } from "react-router-dom";
import PopUpRecallGroup from "../newDocument/popupcomponent/PopUpRecallGroup";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { GridActions, ActionButton, ActionPopup } from '../../../../components/datatable/GridActions';
// JournalCode
export const columns = [
    // { field: 'num', headerName: 'NO', width: 90 },
    {
        field: 'journalGroupID',
        headerName: 'Group ID',
        width: 150,
        // editable: true,
    },
    {
        field: 'confirmDateTime',
        headerName: 'Confirm DateTime',
        // type: 'number',
        width: 150,
        // editable: true,
    },
    // {
    //     field: 'purposer',
    //     headerName: 'Purposer',
    //     width: 200,
    //     editable: true,
    // },
    {
        field: 'userRequest',
        headerName: 'User Request',
        // type: 'number',
        width: 150,
        // editable: true,
    },
    // {
    //     field: 'refECN',
    //     headerName: 'ref ECN',
    //     // type: 'number',
    //     width: 150,
    //     editable: true,
    // },
    {
        field: 'createName',
        headerName: 'Name Create',
        // type: 'number',
        width: 150,
        // editable: true,
    },
    {
        field: 'flow',
        headerName: 'Flow State',
        sortable: false,
        width: 250,
        renderCell: (params) => {
            return (
                <div style={{ flexDirection: 'row', alignContent: 'flex-start', display: 'flex' }}>
                    <Stepflow
                        stateflow={params.row.stateflow}
                        endstateflow={params.row.endstateflow}
                        statusflow={params.row.statusflow}
                        activerecieved={params.row.activerecieved}
                        activeapproved={params.row.activeapproved}
                    />

                </div>
            )
        }

    },
    {
        field: 'actions',
        type: 'actions',
        headerName: 'Actions',
        width: 200,
        minWidth: 200,
        sortable: false,
        cellClassName: 'actions',
        renderCell: (params) => {
            const row = params.row;
            return (
                <GridActions>
                    {row.actions == '102' &&
                        <ActionButton to={`/approvejournalgroup/${row.journalGroupID}/${row.actions}`} title="Approved" tone="send">
                            <BsSendCheckFill />
                        </ActionButton>}
                    {row.actions == '111' &&
                        <ActionButton to={`/approvejournalgroup/${row.journalGroupID}/${row.actions}`} title="View" tone="view">
                            <VisibilityIcon />
                        </ActionButton>}
                    {row.actions == '203' &&
                        <ActionButton to={`/editjournalgroup/${row.journalGroupID}/${row.actions}`} title="Edit" tone="edit">
                            <RiFileEditFill />
                        </ActionButton>}
                    <ActionPopup tone="flow"><PopUpViewFlowstatus jourId={row.JournalID} /></ActionPopup>
                </GridActions>
            )
        }
    }
];